export async function getDownloadSpeed() {
  const fileSize = 1.7; // MB
  const downloadUrl = `/assets/file_1.zip?t=${Date.now()}`; // URL of the file to download
  const startTime = performance.now(); // start time in milliseconds

  const response = await fetch(downloadUrl);
  await response.blob();
  const endTime = performance.now(); // end time in milliseconds
  const downloadTime = (endTime - startTime) / 1000; // download time in seconds
  const speedMbps = fileSize / downloadTime; // download speed in Mbps
  console.log('Estimated download speed:', speedMbps, 'Mbps');
  return speedMbps;
}
